import StaticContent from "../../util/static";

const Legal = () => {


    return <><StaticContent name={"Legal"} /></>
}


export default Legal